import { Controller } from "@hotwired/stimulus"
import { useDebounce } from "stimulus-use"

export default class extends Controller {
  static targets = ["form", "results", "modalBody"]
  static debounces = [{ name: "submitForm", wait: 500 }]

  initialize() {
    this.submitForm()
  }

  connect() {
    useDebounce(this)
  }

  formTargetConnected(form) {
    Array.from(form.elements).forEach((input) => {
      input.addEventListener("change", () => {
        this.pushFormParamsToUrl()
        this.submitForm()
      })
    })
  }

  resultsTargetConnected() {
    window.scrollTo({ top: 0 })
  }

  submitForm() {
    this.formTarget.requestSubmit()
  }

  pushFormParamsToUrl() {
    const url = new URL(location)
    url.search = ""
    Array.from(this.formTarget.elements)
      .filter((element) => element.type != "submit")
      .forEach((element) => {
        if (!element.value) return
        if (["checkbox", "radio"].includes(element.type) && !element.checked) return

        url.searchParams.append(element.name, element.value)
      })
    history.pushState({}, "", url)
  }

  scrollModalBodyToTop() {
    setTimeout(() => this.modalBodyTarget.scrollTo({ top: 0 }), 200)
  }
}
